import React from "react";
import { GetCorServicei } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
require('./../_css/PopUpOther.css');
export default class PopUpCloseSublist extends React.Component {
    constructor(props) {
        super(props);
        this.BuyDate = React.createRef();
        this.Calendar1 = React.createRef();
        this.Code = React.createRef();
        this.state = {
            col: [],
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
            docno: ""
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event, data) => {
        console.log(event, data);
        var dataArray = [];
        var code = ""
        if (event === "true") {
            code = "&docno=" + this.state.docno
        } else {
            code = "&docno=" + this.Code.current.value
        }

        var Url = "CSV_SALEREFDOCNO3/getsubdocno?arcode=" + this.props.ARCODE + code;
        GetCorServicei(Url, "").then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].ISSQTY,
                        Col6: res.data[i].ISSREM,
                        Col7: res.data[i].SHIPQTY,
                        Col8: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col12: res.data[i].SHIPREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        SB: "0",
                    }
                    j++;
                }

                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
        this.setState({ rows: this.state.rows });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {


    }
    /* setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1 };
        }
        this.setState({ rows: data });
    }; */
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        var dataArray = this.state.rows;
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }

    onSelectRow = (data, col, id, row) => {
        this.setState({ valueRetuen: data.code });

        if (col > 1 && data.Col1 !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            this.setState({ Col1: data.Col1 });
            console.log(data.Col1);
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                console.log(this.state.rows[i].SB);
                if (this.state.rows[i].SB === "1") {
                    reData[j] = {
                        Col1: this.state.rows[i].Col1,
                        Col2: this.state.rows[i].Col2,
                        Col3: this.state.rows[i].Col3,
                        Col4: this.state.rows[i].Col4,
                        Col5: this.state.rows[i].Col5,
                        Col6: this.state.rows[i].Col6,
                        Col7: this.state.rows[i].Col7,
                        Col8: this.state.rows[i].Col8,
                        Col9: this.state.rows[i].Col9,
                        Col10: this.state.rows[i].Col10,
                        Col11: this.state.rows[i].Col11,
                        Col12: this.state.rows[i].Col12,
                        Col13: this.state.rows[i].Col13,
                        Col14: this.state.rows[i].Col14,
                        _unitCode: this.state.rows[i]._unitCode,
                        _refLineID: this.state.rows[i]._refLineID,
                    }
                    j++
                }
            }
            /* console.log(reData.length); */
            if (reData.length !== 0) {
                this.props.Get_PopUpSelSaleRef3Sub(reData);
            }
        }
    }
    onSubmit = (e) => {
        var sb_length = 0;
        var reData = [];
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            console.log(this.state.rows[i].SB);
            if (this.state.rows[i].SB === 1) {
                sb_length = sb_length + 1;
                reData[i] = {
                    Col1: this.state.rows[i].Col1,
                    Col2: this.state.rows[i].Col2,
                    Col3: this.state.rows[i].Col3,
                    Col4: this.state.rows[i].Col4,
                    Col5: this.state.rows[i].Col5,
                    Col6: this.state.rows[i].Col6,
                    Col7: this.state.rows[i].Col7,
                    Col8: this.state.rows[i].Col8,
                    Col9: this.state.rows[i].Col9,
                    Col10: this.state.rows[i].Col10,
                    Col11: this.state.rows[i].Col11,
                    Col12: this.state.rows[i].Col12,
                    Col13: this.state.rows[i].Col13,
                    Col14: this.state.rows[i].Col14,
                    _unitCode: this.state.rows[i]._unitCode,
                    _refLineID: this.state.rows[i]._refLineID,
                }
            }
        }
        if (reData.length === sb_length && reData.length !== 0) {
            this.props.Get_PopUpSelSaleRef3Sub(reData);
        }
    };
    /* _chkload = (cell, row, enumObject, rowIndex) => {
        return (
            <div>
                <i id={"load" + rowIndex}>{rowIndex + 1}</i>
            </div>
        );
    }; */
    render() {
        return (

            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner'>{/* popup_inner_arinvdebt divBox */}
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1">
                            <i class="fas fa-search"> ประวัติพนักงานขาย</i>
                        </div>
                        <div class="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i class="fas fa-times"></i>
                        </div>
                    </div>

                    <div class="panel-body divTable" align="right">
                        <div class="row">
                            <div class="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span class="input-group-addon">รหัสพนักงาน : </span>
                                    <input type="text" class="form-control" ref={this.BuyDate} />
                                    <span class="input-group-addon icon">{/* <SelectFix type="Calendar" SelectSetData={this.SelectSetData} /> */}</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span class="input-group-addon">ชื่อพนักงาน : </span>
                                    <input type="text" class="form-control" ref={this.Calendar1} />
                                    <span class="input-group-addon icon">{/* <SelectFix type="Calendar1" SelectSetData={this.SelectSetData} /> */}</span>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "30px" }}>
                            <BootstrapTable
                                data={this.state.rows}
                                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา" }}
                                height="400"
                                hover condensed /* search */>
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey /* dataFormat={this._chkload.bind(this)} */ ><div onClick={this.props.closePopup}><i class="fas fa-reply-all" ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i class={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="120" dataField='Col2' > รหัสสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > ชื่อสินค้า</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Jan</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Fab</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Mar</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Q1</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Apr</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > May</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Jun</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Q2</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Jul</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Aug</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Sep</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Q3</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Oct</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Nov</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Dec</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Q4</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > Sum</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        {this.state.TableHidden ? ("") : (
                            <button class="PUSDbtn" onClick={this.props.closePopup} >
                                <i class="fas fa-reply-all"> กลับ </i>
                            </button>
                        )}
                        <button class="PUSDbtn" onClick={this.onSubmit}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}